import { BusEvent } from '@web/common';

export class WarehouseLocalizationCreatedBusEvent extends BusEvent {}
